<div
    [class.form-group]="field.inputType !== 'divider'"
    [class.mt-3]="field.inputType === 'file' || field.inputType === 'dialog-file'"
    [class]="field.formGroupClass.join(' ')"
>
    <lib-input-label
        *ngIf="
            field.inputType !== 'divider' &&
            field.inputType !== 'noop' &&
            field.inputType !== 'button' &&
            field.inputType !== 'desc'
        "
        [field]="field"
        [name]="name"
        [filter]="filter"
    ></lib-input-label>

    @switch (field.inputType) { @case ('nop') {
    <div>
        <lib-nop-input [name]="name"></lib-nop-input>
    </div>
    } @case ('textbox') {
    <!-- Input type: text -->
    <lib-textbox-input [control]="field" [name]="name"></lib-textbox-input>
    } @case ('password') {
    <!-- Input type: Password -->
    <lib-password-input [control]="field" [name]="name"></lib-password-input>
    } @case ('textarea') {
    <!-- Input type: textarea -->
    <lib-textarea-input [control]="field" [name]="name"></lib-textarea-input>
    }@case ('select') {
    <!-- Input type: select -->
    <lib-select-input [control]="field" [name]="name"></lib-select-input>
    }@case ('multi-select') {
    <!-- Input type: multi-select -->
    <lib-multi-select-input [control]="field" [name]="name"></lib-multi-select-input>
    }@case ('autocomplete') {
    <!-- Input type: autocomplete -->
    <lib-autocomplete-input [control]="field" [name]="name"></lib-autocomplete-input>
    }@case ('checkbox') {
    <!-- Input type: checkbox -->
    <lib-checkbox-input [control]="field" [name]="name"></lib-checkbox-input>
    }@case ('radios') {
    <!-- Input type: radios -->
    <lib-radios-input [control]="field" [name]="name"></lib-radios-input>
    }@case ('date') {
    <!-- Input type: date -->
    <lib-date-input [name]="name" [control]="field"></lib-date-input>
    } @case ('color-picker') {

    <lib-color-picker-input [control]="field" [name]="name"></lib-color-picker-input>
    <!-- <p>BaseInput.statusMessage: {{ field.statusMessage | json }}</p> -->
    } @case ('file-upload') {
    <lib-file-upload-input [control]="field" [name]="name"></lib-file-upload-input>
    } @case ('toggle') {
    <lib-switch-input [control]="field" [name]="name"></lib-switch-input>
    } @case ('sliderWithTextbox') {
    <lib-slider-with-textbox-input
        [control]="field"
        [formControl]="field"
        [name]="name"
    ></lib-slider-with-textbox-input>
    }@case ('array') {
    <lib-form-array [name]="name" [form]="form" [array]="field"></lib-form-array>
    } } @if (field.helpText) {
    <small id="{{ field.name }} + '-help"
        ><em>{{ field.helpText }}</em></small
    >
    } @if (field.inputType !== 'divider' && field.inputType !== 'noop') {
    <lib-validation-input-message
        [statusMessage]="field.statusMessage"
        [fcErrors]="field.errors || []"
    ></lib-validation-input-message>
    }
</div>
